export default __webpack_public_path__ + "static/media/Hassam Shaikh.31223cc2.jpg";